import { h, Host } from '@stencil/core';
import { store, setLinearProductData, ACTION_TYPES, tryParse } from '@pes-ui/utils';
export class DescriptionAndSpecifications {
  constructor() {
    this.runtimeInfo = undefined;
    this.characteristicTables = undefined;
    this.productCharacteristicsLabel = undefined;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.descriptionImages = undefined;
    this._runtimeInfo = undefined;
    this._characteristicTables = undefined;
    this._productCharacteristicsLabel = undefined;
    this._showMoreLabel = undefined;
    this._showLessLabel = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._descriptionImages = undefined;
    this.longDescSentencesTitle = undefined;
    this.longDescSentences = undefined;
    this._longDescSentencesTitle = undefined;
    this._longDescSentences = undefined;
    this.awardsLabel = undefined;
    this.productsAwards = undefined;
    this._awardsLabel = undefined;
    this._productsAwards = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    this.runtimeInfo = (_a = tryParse(this._runtimeInfo)) !== null && _a !== void 0 ? _a : this.runtimeInfo;
    this.characteristicTables = (_b = tryParse(this._characteristicTables)) !== null && _b !== void 0 ? _b : this.characteristicTables;
    this.productCharacteristicsLabel = (_c = tryParse(this._productCharacteristicsLabel)) !== null && _c !== void 0 ? _c : this.productCharacteristicsLabel;
    this.showMoreLabel = (_d = tryParse(this._showMoreLabel)) !== null && _d !== void 0 ? _d : this.showMoreLabel;
    this.showLessLabel = (_e = tryParse(this._showLessLabel)) !== null && _e !== void 0 ? _e : this.showLessLabel;
    this.readMoreLabel = (_f = tryParse(this._readMoreLabel)) !== null && _f !== void 0 ? _f : this.readMoreLabel;
    this.readLessLabel = (_g = tryParse(this._readLessLabel)) !== null && _g !== void 0 ? _g : this.readLessLabel;
    this.descriptionImages = (_h = tryParse(this._descriptionImages)) !== null && _h !== void 0 ? _h : this.descriptionImages;
    this.longDescSentencesTitle = (_j = tryParse(this._longDescSentencesTitle)) !== null && _j !== void 0 ? _j : this.longDescSentencesTitle;
    this.longDescSentences = (_k = tryParse(this._longDescSentences)) !== null && _k !== void 0 ? _k : this.longDescSentences;
    this.awardsLabel = (_l = tryParse(this._awardsLabel)) !== null && _l !== void 0 ? _l : this.awardsLabel;
    this.productsAwards = (_m = tryParse(this._productsAwards)) !== null && _m !== void 0 ? _m : this.productsAwards;
    store.dispatch(setLinearProductData({ specifications: {
        runtimeInfo: this.runtimeInfo,
        characteristicTables: this.characteristicTables,
        productCharacteristicsLabel: this.productCharacteristicsLabel,
        showMoreLabel: this.showMoreLabel,
        showLessLabel: this.showLessLabel,
        longDescSentencesTitle: this.longDescSentencesTitle,
        longDescSentences: this.longDescSentences,
        readMoreLabel: this.readMoreLabel,
        readLessLabel: this.readLessLabel,
        descriptionImages: this.descriptionImages,
        awardsLabel: this.awardsLabel,
        productsAwards: this.productsAwards,
      } }));
    this.unsubscribe = store.subscribe(() => {
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!data[activeProductTab].specifications)
        return;
      const { runtimeInfo, characteristicTables, productCharacteristicsLabel, showMoreLabel, showLessLabel, longDescSentencesTitle, longDescSentences, readMoreLabel, readLessLabel, descriptionImages, awardsLabel, productsAwards, } = data[activeProductTab].specifications;
      this.runtimeInfo = runtimeInfo;
      this.characteristicTables = characteristicTables;
      this.productCharacteristicsLabel = productCharacteristicsLabel;
      this.showMoreLabel = showMoreLabel;
      this.showLessLabel = showLessLabel;
      this.longDescSentencesTitle = longDescSentencesTitle;
      this.longDescSentences = longDescSentences;
      this.readMoreLabel = readMoreLabel;
      this.readLessLabel = readLessLabel;
      this.descriptionImages = descriptionImages;
      this.awardsLabel = awardsLabel;
      this.productsAwards = productsAwards;
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    var _a, _b, _c, _d;
    return (h(Host, null, ((_a = this.longDescSentences) === null || _a === void 0 ? void 0 : _a.length) ? (h("pes-product-description", { class: "description", title: this.longDescSentencesTitle, description: (_b = this.longDescSentences) === null || _b === void 0 ? void 0 : _b.join(' '), readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, descriptionImages: this.descriptionImages })) : null, ((_c = this.productsAwards) === null || _c === void 0 ? void 0 : _c.length) ? (h("pes-product-awards", { title: this.awardsLabel, awards: this.productsAwards })) : null, ((_d = this.characteristicTables) === null || _d === void 0 ? void 0 : _d.length) ? (h("pes-specifications", { runtimeInfo: this.runtimeInfo, characteristicTables: this.characteristicTables, productCharacteristicsLabel: this.productCharacteristicsLabel, showMoreLabel: this.showMoreLabel, showLessLabel: this.showLessLabel })) : null));
  }
  static get is() { return "pes-description-and-specifications"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["./description-and-specifications.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["description-and-specifications.css"]
    };
  }
  static get properties() {
    return {
      "runtimeInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TRuntimeInfo",
          "resolved": "{ product: { id: string; } & TRuntimeAttributes; mainCategory: string; translations: TRuntimeTranslations; }",
          "references": {
            "TRuntimeInfo": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "characteristicTables": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TSpecificationTable[]",
          "resolved": "TSpecificationTable[]",
          "references": {
            "TSpecificationTable": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productCharacteristicsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-characteristics-label",
        "reflect": false
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-less-label",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "descriptionImages": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Array<TDescriptionImageObj>",
          "resolved": "TDescriptionImageObj[]",
          "references": {
            "Array": {
              "location": "global"
            },
            "TDescriptionImageObj": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_runtimeInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-runtime-info",
        "reflect": false
      },
      "_characteristicTables": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-characteristic-tables",
        "reflect": false
      },
      "_productCharacteristicsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-characteristics-label",
        "reflect": false
      },
      "_showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-more-label",
        "reflect": false
      },
      "_showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-less-label",
        "reflect": false
      },
      "_readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-more-label",
        "reflect": false
      },
      "_readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-less-label",
        "reflect": false
      },
      "_descriptionImages": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-description-images",
        "reflect": false
      },
      "longDescSentencesTitle": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "long-desc-sentences-title",
        "reflect": false
      },
      "longDescSentences": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_longDescSentencesTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-long-desc-sentences-title",
        "reflect": false
      },
      "_longDescSentences": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-long-desc-sentences",
        "reflect": false
      },
      "awardsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "awards-label",
        "reflect": false
      },
      "productsAwards": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAward[]",
          "resolved": "TProductAward[]",
          "references": {
            "TProductAward": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_awardsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-awards-label",
        "reflect": false
      },
      "_productsAwards": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-products-awards",
        "reflect": false
      }
    };
  }
}
